import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';
import { getTodaysDate } from 'src/helpers/date';

export function downloadZipAllDocuments(caseManagerId) {
  return axiosRequest('get', serviceUrls.DOWNLOAD_ZIPALLDOCUMENTS, { caseManagerId }, {}, null, {
    dateUTC: getTodaysDate('utc'),
    caseManagerId: caseManagerId,
  });
}

export function generateExecuteSPAPI() {
  return axiosRequest('get', serviceUrls.EXECUTE_SP_API, null, { timeout: 500000 }, null, null);
}

export function getDocumentsAPI(params, config) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_FILTER, params, { timeout: 300000, ...config });
}

export function getLinkedCasesAPI(params, config) {
  return axiosRequest('post', serviceUrls.CASES_GET_LINKED_CASE_LINKEDCASE, params, { timeout: 300000, ...config });

}

export function getSLADetailService(caseManagerId,SLA2Override) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_SLADETAILS, {
    caseManagerId,
    SLA2Override
  });
}

export function getSLAListService() {
  return axiosRequest('get', serviceUrls.GET_SLATYPE_LIST);
}

export function setSLATypeTrigger(caseManagerId = '', profileId = '', caseType = '') {
  return axiosRequest('post', serviceUrls.CASES_UPDATE_CONTACT, {
    caseManagerId,
    profileId,
    caseType,
  });
}

export function getDeliveryReturnIRCounterService(caseManagerId) {
  return axiosRequest('get', serviceUrls.GET_DELIVERY_RETURN_IRCOUNTER, {
    caseManagerId,
  });
}

export const missingDocumentsAPI = caseManagerId => {
  return axiosRequest('post', serviceUrls.MISSING_DOCUMENTS_SERVICE, {
    caseManagerId,
    isMissingDocuments: true,
  });
};

export const allDocsReceivedByEYAPI = caseManagerId => {
  return axiosRequest('post', serviceUrls.ALL_DOCs_RECEIVED_SERVICE, {
    caseManagerId,
    isAllDocsReceivedByEY: true,
  });
};

export const saveOverrideExternalSLAService = (caseManagerId, OverrideExternalSLADate) => {
  return axiosRequest('post', serviceUrls.SAVE_OVERRIDE_EXTERNALSLA_SERVICE, {
    caseManagerId: caseManagerId,
    OverrideExternalSLADate: OverrideExternalSLADate,
  });
};

export function searchDocuments(email) {
  return axiosRequest('get', serviceUrls.AUTOCOMPLETE_SERVICE, {
    email: email,
  });
}

export function uploadDocsService(data, applicantId, config, caseManagerId) {
  const headerParams = {
    applicantId: applicantId,
    "caseManagerId": caseManagerId
  };
  return axiosRequest(
    'post',
    serviceUrls.DOCUMENTS_UPLOAD,
    data,
    {
      timeout: 180000,
      ...config,
    },
    null,
    headerParams,
  );
}

export function fetchClientsService() {
  return axiosRequest('get', serviceUrls.DOCUMENTS_CLIENTS, {}, {}, null, {
    dateUTC: getTodaysDate('utc'),
  });
}

export function fetchDocTypesService(clientId, index, docId = 0) {
  const headerParams = {
    DocumentTypeId: docId,
  };
  return axiosRequest('get', serviceUrls.DOCUMENTS_DOCUMENT_TYPES, { clientId }, {}, null, {
    dateUTC: getTodaysDate('utc'),
    clientId,
    ...headerParams,
  });
}

export function fetchRequestDocTypesService(clientId) {
  const headerParams = {
    IsRequestDocument: 1,
  };
  return axiosRequest('get', serviceUrls.DOCUMENTS_DOCUMENT_TYPES, { clientId }, {}, null, {
    dateUTC: getTodaysDate('utc'),
    clientId,
    ...headerParams,
  });
}

export function saveOtherRequiredDocuments(caseManagerId, documentTypeId, details) {
  return axiosRequest('post', serviceUrls.SAVE_OTHER_REQUEST_DOCUMENTS, {
    caseManagerId: caseManagerId,
    documentTypeId: documentTypeId,
    details: details,
  });
}

export function fetchEmployeesService(clientId) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_EMPLOYEES, { clientId }, {}, null, { dateUTC: getTodaysDate('utc') });
}

export function fetchDocFieldsService(params, caseDocumentTypeId) {
  const headerParams = {
    caseDocumentTypeId: caseDocumentTypeId,
  };
  return axiosRequest('get', serviceUrls.DOCUMENTS_FIELDS, params, {}, null, {
    dateUTC: getTodaysDate('utc'),
    documentTypeId: params.documentTypeId,
    ...headerParams,
  });
}

export function saveDocsService(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE, data, {}, null, {
    dateUTC: getTodaysDate('utc'),
  });
}

export function openDocumentAPI(documentId) {
  return axiosRequest(
    'get',
    serviceUrls.DOCUMENTS_OPEN,
    {
      documentId: documentId,
    },
    { timeout: 180000 },
    null,
    { documentId },
  );
}

export function deleteDocumentAPI(documentId, caseDocumentTypeId) {
  return axiosRequest(
    'post',
    serviceUrls.DOCUMENTS_DELETE,
    {
      documentId: documentId,
      caseDocumentTypeId: caseDocumentTypeId,
    },
    { timeout: 180000 },
  );
}

export function getDocumentDetailsAPI(documentId, caseDocumentTypeId) {
  const headerParams = {
    caseDocumentTypeId: caseDocumentTypeId,
  };
  return axiosRequest(
    'get',
    serviceUrls.DOCUMENTS_VIEW_DETAILS,
    {
      documentid: documentId,
    },
    null,
    null,
    { documentId, ...headerParams },
  );
}

export function getFiltersAPI(config) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_GET_FILTERS, config);
}

export function applyFiltersAPI(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_FILTER, data, { timeout: 300000 });
}

export function fetchNewDocuments(data) {
  return axiosRequest('get', serviceUrls.DASHBOARD_DOCUMENTS, data);
}

export function saveDocUploadService(data) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE_UPLOAD, data, {}, null, { dateUTC: getTodaysDate('utc'), caseManagerId:data.caseManagerId });
}

export function saveDocumentsDetail(params) {
  return axiosRequest('post', serviceUrls.DOCUMENTS_SAVE_DOCUMENT_DETAIL, params, {}, null, { dateUTC: getTodaysDate('utc'), caseManagerId:params.caseManagerId });
}

export function getDocumentGroupService() {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_GROUP);
}

export function getSupportedFileTypes(applicantId) {
  return axiosRequest('get', serviceUrls.DOCUMENTS_GET_SUPPORTED_FILE, {
    applicantId,
  });
}

export function getCaseManagerIdService(profileKey) {
  return axiosRequest('get', serviceUrls.GET_CASE_MANAGER_ID_BY_PROFILE_KEY, {
    profileKey,
  });
}

export function setUploadStatusService(params) {
  return axiosRequest('post', serviceUrls.SET_DOCUMENT_RECEIVED, params, null, null, params);
}

export function setDocumentReceivedService(params) {
  return axiosRequest('post', serviceUrls.SET_DOCUMENT_RECEIVED, params, null, null, params);
}

export function setAcknowledgeDocumentService(params) {
  return axiosRequest('get', serviceUrls.SET_ACKNOWLEDGE_DOCUMNET, params, null, null, params);
}

export const startResumeButton = caseManagerId => {
  return axiosRequest('post', serviceUrls.START_RESUME_BUTTON, {
    caseManagerId : caseManagerId
  });
};

export function setSurePrepOCRChangeService(params) {
  return axiosRequest('post', serviceUrls.SET_SUREPREP_OCR, params, null, null, {  caseManagerId:params.caseManagerId });
}


// WEBPACK FOOTER //
// ./src/services/documents.service.js